import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown'
import {GlossaryDispatch} from '../../Glossary';
import style from './style.module.scss';
import { LogEvent, Log } from '@learningblocks/shared-components';

const GLOSSARY_ITEM_TYPE = {
  VALUE: 'value',
  TITLE: 'title',
};

/**
 * GlossaryListing:
 *   - List fo all items to display in GlossaryList.
 */
export function GlossaryListing(props) {
  const renderGlossaryItem = (glossaryItem) => {
    if (glossaryItem.type === GLOSSARY_ITEM_TYPE.TITLE) {
      return (
        <GlossaryTitleItem key={glossaryItem.id} title={glossaryItem.title} />
      );
    } else {
      return (
        <Log
          term={glossaryItem.title}
          glossary_id={glossaryItem.id}
        >
          <GlossaryValueItem
            key={glossaryItem.id}
            id={glossaryItem.id}
            title={glossaryItem.title}
            selected={glossaryItem.selected}
          /> 
        </Log>
      );
    }
  };

  return (
    <ul className={style.glossaryList}>
      {props.glossaryList.map(renderGlossaryItem)}
    </ul>
  );
}

GlossaryListing.propTypes = {
  /**
   * List of glossaryItems to be displayed in list
   */
  glossaryList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      type: PropTypes.oneOf(['value', 'title']),
    })
  ),
};

GlossaryListing.defaultProps = {
  glossaryList: [],
  loading: false,
  error: false,
};

/**
 * GlossaryValueItem
 *  - The glossary item that display at particular entity
 *  - on clicking the Item its details will be rendered in
 */
function GlossaryValueItem(props) {
  const {onSelectItem} = React.useContext(GlossaryDispatch);

  const onClick = (event) => {
    event.preventDefault();
    onSelectItem(props.id);
  };

  const getClassName = () => {
    return props.selected
      ? style.glossaryList_valueItemSelected
      : style.glossaryList_valueItem;
  };

  const item = useRef();

  useEffect(() => {
    if(props.selected && item.current){
      item.current.parentNode.scrollTop = item.current.offsetTop - 8;
    }
  }, [props.selected, item.current])
  return (
    <LogEvent
    logEventProps={{
      event_type: "sim_id clicked",
      event_schema: "sim_id"
    }}
    actionProps={{ onClick: { action: 'click' }}}
    elementType="button">
      <li
        className={getClassName()}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick();
          }
        }}
        ref={item}
        role="option"
        aria-selected={props.title}
        tabIndex={0}
      >
        <ReactMarkdown>{props.title}</ReactMarkdown>
      </li>
    </LogEvent>
  );
}

GlossaryValueItem.propTypes = {
  /**
   * Unique id for the option
   */
  id: PropTypes.string.isRequired,
  /**
   * title of the option
   */
  title: PropTypes.string.isRequired,
  /**
   * Boolean specifying if the options is selected
   */
  selected: PropTypes.bool.isRequired,
};

GlossaryValueItem.defaultProps = {
  id: 0,
  title: '',
  selected: false,
};

/**
 * GlossaryTitleItem
 *  - The Glossary Item that display the title  category
 */
function GlossaryTitleItem(props) {
  return <li className={style.glossaryList_titleItem}>{props.title}</li>;
}

GlossaryTitleItem.propTypes = {
  /**
   * title of the option
   */
  title: PropTypes.string.isRequired,
};

GlossaryValueItem.defaultProps = {
  title: '',
};
